var styleDataHash = "7b136876";
const injectCss = () => {
  var css = `.-p03Q{display:flex}[dir] .-p03Q{margin:0}.hRYjY{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}[dir] .hRYjY{margin:0;padding:0 4px}.hRYjY:hover{text-decoration:underline}.hRYjY:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.hRYjY.BqRI4{line-height:32px}[dir] .O9SD5{background:transparent;border:0}[dir] .O9SD5:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:640px){.hRYjY{max-width:160px}}}@container (width < 640px){.hRYjY{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "-p03Q",
  "toolbarUrl": "hRYjY",
  "isMobile": "BqRI4",
  "toolbarUrlAnchor": "O9SD5"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
